module.exports = __webpack_public_path__ + "img/1536910775.c265eaf0.jpg";